import { GLServiceBase, ServiceRoute } from "commonui";
import { ICategoryManager } from "./interface";
import { CategoryResponseModel, CreateCategoryRequestModel } from ".";
import { EditCategoryRequestModel, EditTypeRequestModel, CreateTypeRequestModel } from "./model";

class CategoryServiceClass extends GLServiceBase<any, any> implements ICategoryManager {
	serviceRoute: ServiceRoute = { prefix: "content/v1/vcsCategory" };

	createCategory(model: CreateCategoryRequestModel): Promise<boolean> {
		return this.create("addContentCategory", model);
	}

	createType(model: CreateTypeRequestModel): Promise<boolean> {
		return this.create("addContentType", model);
	}

	getCategories(): Promise<CategoryResponseModel[]> {
		return this.get("getContentCategories");
	}

	editCategory(model: EditCategoryRequestModel): Promise<boolean> {
		return this.update("editContentCategory", model, undefined);
	}

	editType(model: EditTypeRequestModel): Promise<boolean> {
		return this.update("editContentType", model, undefined);
	}

	getTypeDocsCount(typeId: number): Promise<number> {
		return this.get("getContentTypeDocumentCount", { contentTypeId: typeId });
	}

	deleteCategory(categoryId: number): Promise<number> {
		return this.delete(`deleteContentCategory?contentCategoryId=${categoryId}`);
	}

	deleteType(typeId: number): Promise<number> {
		return this.delete("deleteContentType", { contentTypeId: typeId });
	}

	moveDocuments(fromTypeId: number, toTypeId: number): Promise<boolean> {
		return this.update(`moveContentDocuments?fromContentTypeId=${fromTypeId}&toContentTypeId=${toTypeId}`);
	}
}

export const CategoryManagerService = () => new CategoryServiceClass();
